import React, { useEffect, useState } from 'react';
import { AirtopClient, AirtopError } from '@airtop/sdk';
import { useSearchParams } from 'react-router-dom';

const PaymentCallback: React.FC = () => {

    // Initialize Airtop client (avoid hardcoding API key in production)
    const airtop = new AirtopClient({ apiKey: '16ac3d42183e4981.weG7flVxMaAfam2UM6b0a3WWgw9Z0PSsnVEd8UI2Ax' }); // Replace with your Airtop API key

    const [cpanelEmail, setCpanelEmail] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [userData, setUserData] = useState<any>({});

   

    const getPaymentToken = async () => {
    try {
      const response = await fetch('https://ksa.paymob.com/api/auth/tokens', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          api_key: 'ZXlKaGJHY2lPaUpJVXpVeE1pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmpiR0Z6Y3lJNklrMWxjbU5vWVc1MElpd2ljSEp2Wm1sc1pWOXdheUk2TVRFME1Ua3NJbTVoYldVaU9pSnBibWwwYVdGc0luMC5ZR2F5ZTdDZGxJN0xFRzFQb0U0RWVTd2lOV0VudEdXcFlQa0F4SVowc1BhcEwwZndvcUFVOFFRb2tfR05HNnlwRzI2OEQwdkdWejd3d3h5V3h5QVpSQQ=='
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if(data.token) {
            handleCheckPayment(data.token);
        }
      } else {
        const errorData = await response.json(); // Parse the JSON error response
      }
    } catch (error) {
      console.error('Error during registration:', error);
    }

  }


  const handleCheckPayment = async (token: string) => {
    if(!token) return;
    try {
      const response = await fetch(' https://ksa.paymob.com/api/ecommerce/orders/transaction_inquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          order_id: searchParams.get("order"),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if(data.success) {
            setPaymentSuccess(true);
        }
      } else {
        const errorData = await response.json(); // Parse the JSON error response
      }
    } catch (error) {
      console.error('Error during registration:', error);
    }
  }

  useEffect(()=>{
    if(searchParams.get("order") && searchParams.get("order") !== '' && searchParams.get("order") !== undefined && searchParams.get("order") !== null) {
        getPaymentToken();
    }
  },[searchParams])



    useEffect(() => {
    if (cpanelEmail) {
      // console.log('cpanelEmail has a value, calling handleAirtopActions:', cpanelEmail);
      handleAirtopActions(cpanelEmail);
    }
  }, [cpanelEmail]);

  useEffect(()=>{
    if(paymentSuccess) {
        // handleSubmit();
        getUserData();
    }
  },[paymentSuccess]);


  const getUserData = async () => {

    try {
      const response = await fetch('https://abmfy-be.onrender.com/users/'+localStorage.getItem('userId'), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        // body: JSON.stringify({ username: email.split('@')[0] }),
      });

      if (response.ok) {
        const data = await response.json();
        setUserData(data);
      } else {
        console.error('Post request failed:', response.statusText);
        // Handle errors (e.g., show an error message)
      }
    } catch (error) {
      console.error('Error sending post request:', error);
      // Handle network errors
    }
  };


  useEffect(()=>{
    if(userData) {
       handleSubmit();
    }
  },[userData])

  const handleSubmit = async () => {
    // event.preventDefault();

    try {
      const response = await fetch('https://abmfy.com/api/c_e.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: userData?.email.split('@')[0] }),
      });

      if (response.ok) {
        const data = await response.json();
        setCpanelEmail(data.email);
        // console.log('Post request successful for email:', email);
        // console.log('cpanelEmail set to:', data.email);
        // Handle success (e.g., show a success message, redirect)
      } else {
        console.error('Post request failed:', response.statusText);
        // Handle errors (e.g., show an error message)
      }
    } catch (error) {
      console.error('Error sending post request:', error);
      // Handle network errors
    }
  };


  // Single function to handle all Airtop actions
  const handleAirtopActions = async (email: string) => {
    try {
      // Validate input
      if (!email) {
        return { status: 'error', message: 'Invalid or missing username' };
      }

      // Step 1: Create a browser session
      const session = await airtop.sessions.create({
        configuration: {
          profileName: 'abmfy',
        },
      });
      const sessionId = session.data.id;

      // Step 2: Create a window (page) and navigate to the form URL
      const window = await airtop.windows.create(sessionId, {
        url: 'https://app.abmfy.com/', // Replace with your form URL
      });
      const windowId = window.data.windowId;

      await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on settings gear icon in the bottom of the left side bar',
      });

      await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on workspaces link from the showed up settings menu',
      });

      await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on Create a new workspace button',
      });

      const monitorPopup = await airtop.windows.monitor(sessionId, windowId, {
        condition: 'Determine if The page does display a section for creating a new workspace with a field for "Workspace name" and toggle button for setting workspace seats limit',
        configuration: {
          interval: {
            intervalSeconds: 5, // Check every 5 seconds
            timeoutSeconds: 30, // Stop after 30 seconds
          },
        },
      });

      if(monitorPopup.data.modelResponse === "{\"conditionMet\":true}") {

      // Step 3: Fill the form using AI
      // await airtop.windows.fillForm(sessionId, windowId, {
      //   automationId: 'auto',
      //   parameters: {
      //     customData: `Name your workspace: ${userData?.company}\n Assign: ${userData?.sets}`,
      //   },
      // });

    await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on workspace seats limit toggle button to be active',
      });

      await airtop.windows.type(sessionId, windowId, {
      text: `${userData?.company}`,
      elementDescription: "input label Name your workspace",
    });

      await airtop.windows.type(sessionId, windowId, {
      text: `${userData?.sets}`,
      elementDescription: 'input number from the left "-" button and from right "+" button',
    });

      // Step 4: Click the start button
      await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on Create Workspace button',
      });

      await airtop.windows.click(sessionId, windowId, {
        elementDescription: `From the settings sidebar tabs click on "Members" tab with icon of ball from the left`,
      });

      await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on Invite Members button',
      });


      await airtop.windows.fillForm(sessionId, windowId, {
        automationId: 'auto',
        parameters: {
          customData: `Enter emails (comma separated): ${email}\n`,
        },
      });

    await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on Role dropdown select input',
      });
      
      await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on Member option from dropdown list of role select input',
      });

await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on choose workspaces dropdown select input',
      });

await airtop.windows.click(sessionId, windowId, {
        elementDescription: `click on the name of company we have just created "${userData?.company}" from choose workspaces dropdown select input`,
      });

 await airtop.windows.fillForm(sessionId, windowId, {
        automationId: 'auto',
        parameters: {
          customData: `check the checkboxs for all options blow this sections "LinkedIn Senders, Leads, My Network, Campaigns, Unibox"`,
        },
      });



      await airtop.windows.click(sessionId, windowId, {
        elementDescription: 'click on Invite members',
      });

      const monitorSuccess = await airtop.windows.monitor(sessionId, windowId, {
        condition: 'Determine if Invitation results are successful',
        configuration: {
          interval: {
            intervalSeconds: 5, // Check every 5 seconds
            timeoutSeconds: 30, // Stop after 30 seconds
          },
        },
      });

      if(monitorSuccess.data.modelResponse === "{\"conditionMet\":true}") {
        await airtop.windows.click(sessionId, windowId, {
          elementDescription: 'click anywhere on the page',
        });

        await airtop.windows.click(sessionId, windowId, {
          elementDescription: 'click on the copy icon in the row of the last invited user',
        });


        await airtop.windows.close(sessionId, windowId); // Close the window first
        await airtop.sessions.terminate(sessionId);


      }

    }

      // // Step 5: Monitor for successful registration
      // const monitorResult = await airtop.windows.monitor(sessionId, windowId, {
      //   condition: 'Determine if the user is successfully registered and redirected to dashboard',
      //   configuration: {
      //     interval: {
      //       intervalSeconds: 5, // Check every 5 seconds
      //       timeoutSeconds: 30, // Stop after 30 seconds
      //     },
      //   },
      // });

      // // console.log('Monitoring result:', monitorResult);
      // if(monitorResult.data.modelResponse === "{\"conditionMet\":true}") {
      //   // setRegistrationSuccess(true);
      // }

      // // Step 6: Terminate the session
      // await airtop.windows.close(sessionId, windowId); // Close the window first
      // await airtop.sessions.terminate(sessionId); // Then terminate the session

      // return {
      //   status: 'success',
      //   message: 'Form filling, start button click, and registration monitoring initiated successfully.',
      //   monitoringResult: monitorResult,
      // };
    } catch (error: any) {
      // console.error('Airtop Error:', error);
      if (error instanceof AirtopError) {
        // console.log('Status Code:', error.statusCode, 'Body:', error.body); // Handle Airtop-specific errors
      }
      return {
        status: 'error',
        message: error.message || 'Failed to process Airtop actions',
      };
    }
  };

   const validateOrderId = () => {
    const getOrderId : any = searchParams.get("order");
    if(!getOrderId) return true;
    return false;
   }

   if(validateOrderId()) {
    return <div>Error you must follow wrong url.</div>
   }

  return (
    <div>
      <h2>Thank you</h2>
      <p>We are processing your payment...</p>
      <p>Please wait a few minutes. and don't close this page.</p>
      <div style={{textAlign: 'center'}}>
        <img src="/spinner.svg" className='loading-spinner' alt="" />
      </div>
    </div>
  );
};

export default PaymentCallback;